<template>


  <section class="m-auto mb-8 text-center max-w-2screen-lg lg:mb-16">

    <div class="relative w-full max-w-6xl pt-12 m-auto bg-white text-21 sm-max:px-5">

      <div class="px-10 pb-20 space-y-8 sm-max:p-0">
        <div class="border-2 bg-indonesiaNew border-greenD">

          <div class="grid grid-cols-8">

            <div class="col-span-3 z-[1] md-max:col-span-8 sm-max:p-4">
              <nuxt-img
                  class="m-auto lg:w-full md-max:mt-2 lg:-mt-2 lg:-ml-2"
                  width="389"
                  height="370"
                  loading="lazy"
                  format="webp"
                  alt="SINGLE ORIGIN"
                  src="/assets/images/freebag-sect3-img2.png"
              ></nuxt-img>
            </div>

            <div class="col-span-5 text-left md-max:col-span-8 md-max:text-center md-max:px-6">

              <div
                  class="inline-block px-10 py-3 text-white bg-indonesiaYellow h2 sm-max:w-full sm-max:px-6 lg:mt-8 lg:-ml-8">

                SINGLE ORIGIN
              </div>

              <div class="pb-6 mt-4 font-medium text-left text-gray-900 textp md-max:pb-10 md-max:text-center lg:pr-6 ">
                <p>Most of the coffee for sale in retail stores and coffee shops is a mix-match of beans from various
                  plants
                  and countries around the world. With blends, you might get beans mixed with pesticide-soaked beans. It’s
                  also possible you can get premium dark roast beans mixed with under-dried, toxin-filled lighter roast
                  beans.</p>
                <p class="mt-5">Single Origin coffee ensures you’re getting what you pay for - and nothing you don’t want
                  in
                  your coffee. <strong>Every bag of this coffee, however, is guaranteed single origin</strong>. Each bag
                  is
                  filled with beans from the same region and the same roast profile.</p>
              </div>

            </div>

          </div>

        </div>

        <div class="border-2 bg-indonesiaNew border-greenD">

          <div class="grid grid-cols-8">

            <div class="col-span-3 z-[1] md-max:col-span-8 sm-max:p-4">
              <nuxt-img
                  class="m-auto lg:w-full md-max:mt-2 lg:-mt-2 lg:-ml-2"
                  width="389"
                  height="370"
                  loading="lazy"
                  format="webp"
                  alt="MYCOTOXIN-FREE"
                  src="/assets/images/freebag-sect3-img3.png"
              ></nuxt-img>
            </div>

            <div class="col-span-5 text-left md-max:col-span-8 md-max:text-center md-max:px-6">

              <div
                  class="inline-block px-10 py-3 text-white bg-indonesiaYellow h2 sm-max:w-full sm-max:px-6 lg:mt-8 lg:-ml-8">

                MYCOTOXIN-FREE
              </div>

              <div class="pb-6 mt-4 font-medium text-left text-gray-900 textp md-max:pb-10 md-max:text-center lg:pr-6">
                <p>Mycotoxins are mold toxins that can occur in many substances. Naturally, that means <strong>they can
                  grow
                  inside coffee beans too</strong>. (Unfortunately, they’re far more common than you may think.)
                  Mycotoxins
                  can trigger anything from painful, full-body inflammation to debilitating Chronic Fatigue Syndrome.
                  Several studies have also strongly linked mycotoxins with kidney diseases.</p>
              </div>

            </div>

          </div>

        </div>


        <div class="border-2 bg-indonesiaNew border-greenD">

          <div class="grid grid-cols-8">

            <div class="col-span-3 z-[1] md-max:col-span-8 sm-max:p-4">
              <nuxt-img
                  class="m-auto lg:w-full md-max:mt-2 lg:-mt-2 lg:-ml-2"
                  width="389"
                  height="370"
                  loading="lazy"
                  format="webp"
                  alt="SHADE GROWN"
                  src="/assets/images/freebag-sect3-img4.png"
              ></nuxt-img>
            </div>

            <div class="col-span-5 text-left md-max:col-span-8 md-max:text-center md-max:px-6">

              <div
                  class="inline-block px-10 py-3 text-white bg-indonesiaYellow h2 sm-max:w-full sm-max:px-6 lg:mt-8 lg:-ml-8">


                SHADE GROWN
              </div>

              <div class="pb-6 mt-4 font-medium text-left text-gray-900 textp md-max:pb-10 md-max:text-center lg:pr-6">
                <p>For the best-tasting coffee, you don’t want the sun beating down on the beans, harming the natural
                  maturation and rich, complex flavor. Only <strong>2% of the world’s coffee is shade-grown</strong>. With
                  shade-grown coffee, <span class="underline">no pesticides are needed</span>. You deserve natural,
                  unharmed, and pure coffee.</p>
              </div>

            </div>

          </div>

        </div>


        <div class="border-2 bg-indonesiaNew border-greenD">

          <div class="grid grid-cols-8">

            <div class="col-span-3 z-[1] md-max:col-span-8 sm-max:p-4">
              <nuxt-img
                  class="m-auto lg:w-full md-max:mt-2 lg:-mt-2 lg:-ml-2"
                  width="389"
                  height="370"
                  loading="lazy"
                  format="webp"
                  alt="STOMACH-FRIENDLY"
                  src="/assets/images/freebag-sect3-img5.png"
              ></nuxt-img>
            </div>

            <div class="col-span-5 text-left md-max:col-span-8 md-max:text-center md-max:px-6">

              <div
                  class="inline-block px-10 py-3 text-white bg-indonesiaYellow h2 sm-max:w-full sm-max:px-6 lg:mt-8 lg:-ml-8">


                STOMACH-FRIENDLY
              </div>

              <div class="pb-6 mt-4 font-medium text-left text-gray-900 textp md-max:pb-10 md-max:text-center lg:pr-6">
                <p>One of the biggest complaints about coffee is the digestive discomfort from some brews. You probably know all about it yourself… heartburn, indigestion, bathroom trips, and more. <strong>Sometimes you just don’t know what a given coffee is going to do to your stomach!</strong></p>

                <p class="mt-5">A lot of that discomfort has to do with the acid in your stomach. And you may also
                  know
                  the discomfort depends on the type of roast you drink. <strong>(Hint: Medium and Dark Roasts are easier
                    on
                    the stomach!)</strong> So it can be a gamble as to how your stomach will handle a new coffee.</p>

                <p class="mt-5">But because of the steps you’ve just read about above, <span class="underline">Lifeboost Coffee guarantees its coffee won’t bother your stomach</span>!
                  There’s nothing inside that can trigger excess stomach acid or affect digestion.</p>

                <p class="mt-5"><strong>Light, medium, dark or decaf, you choose your beans and your stomach is
                  happy.</strong></p>

              </div>


            </div>

          </div>

          <div class="mx-10 mt-5 mb-10 bg-white border-2 border-greenD sm-max:mx-4">

            <div class="grid items-center px-8 py-6 md-max:px-5 md:grid-cols-9">
              <div class="col-span-3 md-max:col-span-9">

                <nuxt-img
                    class="m-auto lg:w-full md-max:mt-2"
                    width="211"
                    height="201"
                    loading="lazy"
                    format="webp"
                    alt="STOMACH-FRIENDLY"
                    src="/assets/images/freebag-sect3-4logos.png"
                ></nuxt-img>

              </div>

              <div class="col-span-6 md-max:col-span-9">

                <div class="textp md-max:text-center md-max:pt-4">
                  <p>On top of low acidity, Lifeboost Coffee has none of the junk swimming around in most coffees that
                    aggravates your stomach. That means <strong>no pesticides, chemicals, GMOs, or mycotoxins.</strong>
                  </p>
                  <p class="pt-5">That means nothing that careless farmers and profit-hungry manufacturers used to get
                    their
                    brews out the door fast.</p>
                </div>

              </div>
            </div>

          </div>

        </div>
      </div>


      <div class="px-8 pt-12 pb-10 space-y-8 sm-max:px-5 md-max:pb-6 bg-indonesiaGreen">


        <div>

          <div class="text-left">
            <div
                v-for="item in items"
                :key="item.id"
                :class="item.id==0? 'm-0.5':''"
                class="grid items-start gap-8 md:grid-cols-8 md-max:mb-16 sm-max:gap-3"
            >
              <div class="col-span-3 md-max:col-span-8">
                <nuxt-img
                    class="object-cover object-bottom m-auto max-h-72"
                    width="390"
                    height="287"
                    loading="lazy"
                    :class="item.id==0? 'p-3 bg-white' :''"
                    format="webp"
                    :alt="item.alt"
                    :src="item.imageSrc"
                ></nuxt-img>
              </div>

              <div class="col-span-5 md-max:col-span-8 md-max:text-center">
                <h3 class="text-white uppercase h2">{{ item.title }}</h3>

                <p class="mt-5 text-white textp md-max:text-center sm-max:mt-2"
                   v-html="item.description"></p>
              </div>
            </div>
          </div>

        </div>

        <div id="testimonial">

        </div>
      </div>
    </div>


  </section>


</template>

<script>
export default {
  data() {
    return {
      items: [
        {
          id: 1,
          alt: 'HIGH ELEVATION GROWN',
          imageSrc: '/assets/images/freebag-include-img1.png',
          title: 'High Elevation Grown',
          description:
              'High-altitude specialty coffees, generally command a far better market price due to their exceptional flavor and vibrancy, lower yield per coffee tree, and challenge to coffee farmers in remote mountainous areas. This means truly superb coffee beans that represent one of the world\'s most affordable luxuries.',
        },
        {
          id: 0,
          alt: 'Experience Tradition in Every Sip',
          imageSrc: '/assets/images/indonesia-farmer.jpg',
          title: 'Experience Tradition in Every Sip',
          description:
              'Our Giling Basah process, a traditional Sumatran method, hulls parchment at 50% moisture — 5 times more than common methods. This unique practice gives our coffee its signature flavor profile: a low acidity, deep richness, and a symphony of earthy, spicy, and chocolate notes. Taste the tradition that sets our coffee apart."',
        },
        {
          id: 3,
          alt: 'FAIRLY TRADED',
          imageSrc: '/assets/images/freebag-include-img10.jpg',
          title: 'FAIRLY TRADED',
          description:
              'This coffee is grown in a sustainable environment. Farmers grow their coffee which is an environmentally friendly way of producing crops. Not only is this good for the environment, but it is better for the coffee. By employing farming methods, the fairly traded coffee is grown by farmers who are paid a fair wage for doing so.',
        },
        {
          id: 4,
          alt: 'SPECIALTY BEAN',
          imageSrc: '/assets/images/freebag-include-img4.jpg',
          title: 'SPECIALTY BEAN',
          description:
              'Specialty coffee represents the very best of the world’s coffee yield or the TOP 10% of global production. These beans are the largest beans that are hand picked out because they are perfect with no defects. Only the very best.',
        },
        {
          id: 5,
          alt: 'SPECIALTY BEAN',
          imageSrc: '/assets/images/freebag-include-img5.jpg',
          title: 'PESTICIDE-FREE',
          description:
              `Some other coffee farms slash and burn the rainforest and spray their coffee beans with toxic pesticides to keep the bugs away. We think it's better to grow our coffee in chemical-free, nutrient-rich virgin soil.
<br><br>
If you’re anything like me, I prefer to grow our coffee the natural way, in the cool shade of ancient trees, where the beans can ripen slowly and migratory birds, like the beautiful Scarlet Tanager, can naturally manage bugs like the coffee farmer's archenemy - the coffee borer.`
        },
        {
          id: 6,
          alt: 'CHEMICAL-FREE',
          imageSrc: '/assets/images/freebag-include-img6.jpg',
          title: 'CHEMICAL-FREE',
          description:
              `Conventional coffee farms soak the ground with harsh chemical fertilizers - as much as 250 pounds per acre! When you grind up beans that have chemical residue and add hot water to them, you concentrate those chemicals into your cup of coffee.`
        },
        {
          id: 7,
          alt: 'NON-GMO',
          imageSrc: '/assets/images/freebag-include-img7.jpg',
          title: 'NON-GMO',
          description:
              `Our beans are grown from single origin plants that have not been genetically modified. We believe in keeping our coffee as clean and pure as possible not just for health reasons, but to protect the environment and the delicate flavor profile that you get with every perfect cup.`
        },
      ],
    };
  },
};
</script>


<script setup>

defineBuilderComponent({
    friendlyName: 'Content_Section_3',
    ignored: true
})

</script>